import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Card,
  Table,
  CardGroup,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { GrPowerReset } from "react-icons/gr";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import {
  getAllDailyExpenses,
  deleteDailyExpense,
  resetExpenseList,
  resetExpenseDelete,
} from "../features/dailyexpense/dailyExpenseSlice";
import moment from "moment";
import { logout } from "../features/user/userSlice";
import { LinkContainer } from "react-router-bootstrap";

const DailyExpense = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [allExpenses, setAllExpenses] = useState([]);

  const [selectDateFrom, setSelectDateFrom] = useState("");
  const [selectDateTo, setSelectDateTo] = useState("");

  const { userInfo } = useSelector((state) => state.user);
  const [totalExpense, setTotalExpense] = useState(0);

  const {
    dailyExpenses,

    islistLoading,
    isListError,
    listErrorMessage,
    isListSuccess,

    isDeleteLoading,
    isDeleteError,
    deleteErrorMessage,
    isDeleteSuccess,
  } = useSelector((state) => state.dailyExpense);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login To Get Access!!", { position: "top-center" });
      navigate("/login");
    }
    if (userInfo.permissions?.includes("dailyExpense") === false) {
      toast.error("Paknami Keno Koren???", {
        position: "top-center",
      });
      dispatch(logout());
    }
  }, [userInfo, navigate, dispatch]);

  // State to store filtered passports
      const [filteredExpense, setFilteredExpense] = useState([]);

  useEffect(() => {
    if (isListError) {
      toast.error(listErrorMessage, { position: "top-center" });
    } else if (isListSuccess) {
      const filteredExpenses = dailyExpenses.filter((dailyExpense) => {
        if (selectDateFrom === "" || selectDateTo === "") {
          return true;
        } else {
          return (
            new Date(dailyExpense.createdAt) >= new Date(selectDateFrom) &&
            new Date(dailyExpense.createdAt) <= new Date(selectDateTo)
          );
        }
      });
      setAllExpenses(filteredExpenses);
    } else {
      dispatch(getAllDailyExpenses());
    }
  }, [
    dispatch,
    isListSuccess,
    isListError,
    listErrorMessage,
    selectDateFrom,
    selectDateTo,
    dailyExpenses,
  ]);

  useEffect(() => {
    if (isDeleteError) {
      toast.error(deleteErrorMessage, { position: "top-center" });
    } else if (isDeleteSuccess) {
      toast.success("Expense Deleted Successfully", { position: "top-center" });
      dispatch(resetExpenseDelete());
      dispatch(getAllDailyExpenses());
    }
  }, [isDeleteSuccess, isDeleteError, deleteErrorMessage]);

  useEffect(() => {
    return () => {
      dispatch(resetExpenseList());
      dispatch(resetExpenseDelete());
    };
  }, []);

  const handleDelete = (id) => {
    if (
      window.confirm("Are you sure you want to delete this expense record?")
    ) {
      dispatch(deleteDailyExpense(id));
      dispatch(resetExpenseList());
    }
  };

      // pagination
      const [currentPage, setCurrentPage] = useState(1);
      const recordsPerPage = 30;
      const lastIndex = currentPage * recordsPerPage;
      const firstIndex = lastIndex - recordsPerPage;
      const records = allExpenses.slice(firstIndex, lastIndex);
      const npage = Math.ceil(allExpenses.length / recordsPerPage); // Total pages
      const numbers = [...Array(npage + 1).keys()].slice(1);


  return (
    <Container className="my-4">
      {/* <h2 className="mb-4 fw-bold text-center">Daily Expense Records</h2> */}
      <Row className="mb-4">
        <Card
          className="rounded-4 border"
          style={{ backgroundColor: "#e6edf1" }}
        >
          <h2 className="my-3 text-dark text-center fw-bold">
            Daily <span style={{ color: "#5c91dc" }}>Expense</span> Records
          </h2>
        </Card>
      </Row>

      {/* Search Criteria */}
      <Row className="my-4">
        <CardGroup className="p-0">
          <Card>
            <Card.Header
              className="text-center fw-bold text-black"
              style={{ backgroundColor: "#74a2e3" }}
              as="h6"
            >
              Search By Date Range
            </Card.Header>

            <Card.Body>
              <Form>
                <Row>
                  <Col>
                    <Form.Group controlId="selectDateFrom">
                      <Form.Label style={{ color: "black" }}>From</Form.Label>
                      <Form.Control
                        type="date"
                        onChange={(e) => setSelectDateFrom(e.target.value)}
                        className="shadow-rounded"
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group controlId="selectDateTo">
                      <Form.Label style={{ color: "black" }}>To</Form.Label>
                      <Form.Control
                        type="date"
                        onChange={(e) => setSelectDateTo(e.target.value)}
                        className="shadow-rounded"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Card.Body>

            <Card.Footer>
              <Col className="d-flex justify-content-end">
                <Button
                  variant="outline-danger"
                  onClick={() => {
                    setSelectDateFrom("");
                    document.getElementById("selectDateFrom").value = "";
                    setSelectDateTo("");
                    document.getElementById("selectDateTo").value = "";
                  }}
                >
                  <GrPowerReset className="mb-1" /> Reset
                </Button>
              </Col>
            </Card.Footer>
          </Card>
        </CardGroup>
      </Row>

      <Row>
        {/* Table */}
        <Card style={{ backgroundColor: "#74a2e3" }}>
          <Card.Header
            className="text-center text-black p-3 fw-bold"
            style={{ backgroundColor: "#74a2e3" }}
            as="h5"
          >
            Daily Expense List
          </Card.Header>
          <Table responsive bordered hover>
            <thead className="text-center">
              <tr>
                <th>Expense Amount</th>
                <th>Expense Description</th>
                <th>Expense Date</th>
                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {islistLoading ? (
                <Loader />
              ) : (
                <>
                  {records &&
                    records.map((dailyExpense) => (
                      <tr key={dailyExpense?._id}>
                        <td style={{ padding: "0px" }}>
                          {dailyExpense.amount}
                        </td>
                        <td style={{ padding: "0px" }}>
                          {dailyExpense.description}
                        </td>
                        {/* <td>{dailyExpense.createdAt}</td> */}
                        <td style={{ padding: "0px" }}>
                          {/* {new Date(
                            dailyExpense.createdAt
                          ).toLocaleDateString()} */}
                          {moment(dailyExpense.createdAt).format(
                            "Do MMMM YYYY, h:mm:ss a"
                          )}
                        </td>

                        {userInfo?.userType === "admin" ? (
                          <>
                            <td style={{ padding: "0px" }}>
                              <LinkContainer
                                to={`/updateDailyExpense/${dailyExpense._id}`}
                              >
                                <Button className="btn-sm">
                                  <FaEdit />
                                </Button>
                              </LinkContainer>
                            </td>
                            <td style={{ padding: "0px" }}>
                              <Button
                                onClick={() => handleDelete(dailyExpense._id)}
                                variant="danger btn-sm"
                              >
                                <MdDelete />
                              </Button>
                            </td>
                          </>
                        ) : (
                          <>
                            <td style={{ padding: "0px" }}>
                              <Button
                                // onClick={() => handleDelete(dailyExpense._id)}
                                variant="danger"
                                disabled
                              >
                                <MdDelete />
                              </Button>
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                </>
              )}
            </tbody>
          </Table>

          <nav className="d-flex justify-content-center">
            <ul className="pagination">
              <li className="page-item">
                <a href="#" className="page-link" onClick={prePage}>
                  Prev
                </a>
              </li>

              {/* Show the first two pages */}
              {numbers.slice(0, 2).map((n, index) => (
                <li
                  className={`page-item ${currentPage === n ? "active" : ""}`}
                  key={index}
                >
                  <a
                    href="#"
                    className="page-link"
                    onClick={() => changeCPage(n)}
                  >
                    {n}
                  </a>
                </li>
              ))}

              {/* Show ellipsis if currentPage is beyond page 3 */}
              {currentPage > 3 && (
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              )}

              {/* Show the middle range of pages */}
              {numbers
                .slice(
                  Math.max(currentPage - 2, 2),
                  Math.min(currentPage + 1, npage - 1)
                )
                .filter((n) => ![1, npage].includes(n)) // Exclude the first and last page from middle range
                .map((n, index) => (
                  <li
                    className={`page-item ${currentPage === n ? "active" : ""}`}
                    key={index}
                  >
                    <a
                      href="#"
                      className="page-link"
                      onClick={() => changeCPage(n)}
                    >
                      {n}
                    </a>
                  </li>
                ))}

              {/* Show ellipsis if not near the last pages */}
              {currentPage < npage - 2 && (
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
              )}

              {/* Show the last two pages, ensuring they do not repeat */}
              {numbers.slice(-2).map((n, index) =>
                n !== 1 &&
                n !== currentPage &&
                n !== currentPage - 1 &&
                n !== currentPage + 1 ? (
                  <li
                    className={`page-item ${currentPage === n ? "active" : ""}`}
                    key={index}
                  >
                    <a
                      href="#"
                      className="page-link"
                      onClick={() => changeCPage(n)}
                    >
                      {n}
                    </a>
                  </li>
                ) : null
              )}

              <li className="page-item">
                <a href="#" className="page-link" onClick={nextPage}>
                  Next
                </a>
              </li>
            </ul>
          </nav>

        </Card>
      </Row>
    </Container>
  );

  function prePage() {
    if (currentPage > 1) {
      // Check if there's a previous page
      setCurrentPage(currentPage - 1);
    }
  }

  function changeCPage(id) {
    setCurrentPage(id);
  }

  function nextPage() {
    if (currentPage < npage) {
      // Check if there's a next page
      setCurrentPage(currentPage + 1);
    }
  }
};

export default DailyExpense;
